// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {
	$('.p-freeContactForm__date[type="date"]').on('click', function() {
		if (typeof this.showPicker === 'function') {
			this.showPicker();
		}
	});
});

jQuery(function($) {
	var $contactSelects = $('.p-generalContactForm__select');

	function updateContactSelectColor() {
		$(this).toggleClass('is-selected', this.selectedIndex > 0);
	}

	$contactSelects.each(updateContactSelectColor);
	$contactSelects.on('change', updateContactSelectColor);
});

document.addEventListener('DOMContentLoaded', function() {
	var searchResult = document.querySelector('[data-scroll-on-load="true"]');
	if (!searchResult) {
		return;
	}

	window.requestAnimationFrame(function() {
		window.requestAnimationFrame(function() {
			var header = document.querySelector('.l-header');
			var headerHeight = header ? header.offsetHeight : 0;
			var targetTop = searchResult.getBoundingClientRect().top + window.pageYOffset - headerHeight;

			window.scrollTo(0, targetTop);
		});
	});
});

jQuery(function($) {

	if ( $('#cookiePolicy').length > 0 ) {
		var cookiePolicy = $('#cookiePolicy');
		cookiePolicy.hide();
		if(localStorage.getItem('cookieUse') === null) {

			// スクロール時の表示・非表示 // show/hide on scrolling
			$(window).on("scroll", dispAgree);

			// 同意ボタンクリック // click on the agree button
			$('#cookie_agree').on("click", function() {
				$(window).off("scroll", dispAgree);
				localStorage.setItem('cookieUse', 'agree');
				cookiePolicy.hide();
			})
		}

		//スクロールが100に達したらクッキー同意を表示 // Show cookie agreement when scroll reaches 100
		function dispAgree() {
			if ($(this).scrollTop() > 100) {
				cookiePolicy.fadeIn();
			} else {
				cookiePolicy.fadeOut();
			}
		}
	}


});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ページトップボタンの表示 // Display the page top button
jQuery(function($) {

	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});


// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$(this).attr('aria-expanded', $(this).hasClass('toggle_active') ? 'true' : 'false');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('#site-header-nav').addClass('is_open');
				$('#site-header-nav').removeClass('is_close');
			} else {
				$('#site-header-nav').removeClass('is_open');
				$('#site-header-nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('#toggle').attr('aria-expanded', 'false');
			$('body').removeClass('drawer_open');
			$('#site-header-nav').removeClass('is_open');
			$('#site-header-nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('#site-header-nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});

// 物件検索モーダル // Property search modal
jQuery(function($) {
	var $modal = $('#propertySearchModal');

	if ($modal.length === 0) {
		return;
	}

	function openPropertySearchModal() {
		if ($('#toggle').hasClass('toggle_active')) {
			$('#drawer_layer').fadeOut();
			$('#toggle').removeClass('toggle_active').attr('aria-expanded', 'false');
			$('#site-header-nav').removeClass('is_open').addClass('is_close');
			$('body').removeClass('drawer_open');
		}

		$modal.addClass('is-open').attr('aria-hidden', 'false');
		$('body').addClass('modal_open');
		setTimeout(function() {
			$modal.find('input, select, button').filter(':visible').first().trigger('focus');
		}, 50);
	}

	function closePropertySearchModal() {
		$modal.removeClass('is-open').attr('aria-hidden', 'true');
		$('body').removeClass('modal_open');
	}

	$('.js-property-search-open').on('click', function() {
		openPropertySearchModal();
	});

	$('.js-property-search-close').on('click', function() {
		closePropertySearchModal();
	});

	$(document).on('keydown', function(event) {
		if (event.key === 'Escape' && $modal.hasClass('is-open')) {
			closePropertySearchModal();
		}
	});
});

// 物件検索ラジオボタンの選択解除 // Allow selected search radios to be cleared
jQuery(function($) {
	var radioSelector = '.p-propertySearchModal input[type="radio"], .p-residenceFilter input[type="radio"]';
	var radioLabelSelector = '.p-propertySearchModal label:has(input[type="radio"]), .p-residenceFilter label:has(input[type="radio"])';

	$(document)
		.on('pointerdown', radioLabelSelector, function() {
			var $radio = $(this).find('input[type="radio"]').first();
			$radio.data('was-checked', $radio.prop('checked'));
		})
		.on('pointerdown keydown', radioSelector, function(event) {
			if (event.type === 'keydown' && event.key !== ' ' && event.key !== 'Enter') {
				return;
			}

			$(this).data('was-checked', this.checked);
		})
		.on('click', radioSelector, function() {
			if ($(this).data('was-checked')) {
				this.checked = false;
				$(this).data('was-checked', false).trigger('change');
			}
		});
});

// 物件詳細ギャラリーモーダル // Residence gallery modal
jQuery(function($) {
	var $modal = $('#residenceGalleryModal');

	if ($modal.length === 0) {
		return;
	}

	var $mainImage = $modal.find('.js-residence-gallery-main');
	var $current = $modal.find('.js-residence-gallery-current');
	var $thumbs = $modal.find('.js-residence-gallery-thumb');
	var images = [];
	var currentIndex = 0;
	var touchStartX = 0;

	try {
		images = JSON.parse($modal.attr('data-gallery-images') || '[]').map(function(image) {
			return {
				src: image.url || image.src || '',
				alt: image.alt || '',
				width: Number(image.width) || null,
				height: Number(image.height) || null
			};
		}).filter(function(image) {
			return image.src !== '';
		});
	} catch (error) {
		images = [];
	}

	if (images.length === 0) {
		$thumbs.each(function() {
			var $img = $(this).find('img');
			if ($img.attr('src')) {
				images.push({
					src: $img.attr('src'),
					alt: $img.attr('alt') || '',
					width: Number($img.attr('width')) || null,
					height: Number($img.attr('height')) || null
				});
			}
		});
	}

	function showImage(index) {
		if (images.length === 0) {
			return;
		}

		currentIndex = (index + images.length) % images.length;
		$mainImage.attr('src', images[currentIndex].src);
		$mainImage.attr('alt', images[currentIndex].alt);
		if (images[currentIndex].width && images[currentIndex].height) {
			$mainImage.attr('width', images[currentIndex].width);
			$mainImage.attr('height', images[currentIndex].height);
		}
		$current.text(currentIndex + 1);
		$thumbs.removeClass('is-active');
		$thumbs.eq(currentIndex).addClass('is-active');
	}

	function openGallery(index) {
		showImage(index);
		$modal.addClass('is-open').attr('aria-hidden', 'false');
		$('body').addClass('modal_open');
	}

	function closeGallery() {
		$modal.removeClass('is-open').attr('aria-hidden', 'true');
		$('body').removeClass('modal_open');
	}

	$('.js-residence-gallery-open').on('click', function() {
		openGallery(Number($(this).attr('data-gallery-index')) || 0);
	});

	$('.js-residence-gallery-close').on('click', function() {
		closeGallery();
	});

	$('.js-residence-gallery-prev').on('click', function() {
		showImage(currentIndex - 1);
	});

	$('.js-residence-gallery-next').on('click', function() {
		showImage(currentIndex + 1);
	});

	$thumbs.on('click', function() {
		showImage(Number($(this).attr('data-gallery-index')) || 0);
	});

	$modal.on('click', function(event) {
		if ($(event.target).is($modal)) {
			closeGallery();
		}
	});

	$modal.on('touchstart', '.p-residenceGalleryModal__image', function(event) {
		touchStartX = event.originalEvent.touches[0].clientX;
	});

	$modal.on('touchend', '.p-residenceGalleryModal__image', function(event) {
		var touchEndX = event.originalEvent.changedTouches[0].clientX;
		var distance = touchEndX - touchStartX;

		if (Math.abs(distance) < 40) {
			return;
		}

		showImage(distance > 0 ? currentIndex - 1 : currentIndex + 1);
	});

	$(document).on('keydown', function(event) {
		if (!$modal.hasClass('is-open')) {
			return;
		}

		if (event.key === 'Escape') {
			closeGallery();
		}

		if (event.key === 'ArrowLeft') {
			showImage(currentIndex - 1);
		}

		if (event.key === 'ArrowRight') {
			showImage(currentIndex + 1);
		}
	});
});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-accordion-title').forEach(function(title) {
    title.addEventListener('click', function() {
      title.classList.toggle('is-open');
      var content = title.nextElementSibling;
      content.classList.toggle('is-open');
    });
  });
});

// トップ低層マンション紹介 スクロールアニメーション
document.addEventListener('DOMContentLoaded', function() {
  var lowriseList = document.querySelector('.p-frontLowrise__list');
  var lowriseItems = Array.prototype.slice.call(document.querySelectorAll('.p-frontLowrise__item'));
  var lowriseFigures = Array.prototype.slice.call(document.querySelectorAll('.p-frontLowrise__figure'));

  if (!lowriseList || lowriseItems.length === 0 || lowriseFigures.length === 0) {
    return;
  }

  if (window.innerWidth <= 768) {
    return;
  }

  var ticking = false;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function resetLowriseItems() {
    lowriseFigures.forEach(function(figure) {
      figure.style.removeProperty('--lowrise-reveal');
    });
  }

  function updateLowriseItems() {
    ticking = false;

    if (window.innerWidth <= 768) {
      resetLowriseItems();
      return;
    }

    var viewportHeight = window.innerHeight;
    var start = viewportHeight * 0.72;
    var end = viewportHeight * 0.28;

    lowriseItems.forEach(function(item, index) {
      var figure = lowriseFigures[index];

      if (!figure) {
        return;
      }

      if (index === 0) {
        figure.style.setProperty('--lowrise-reveal', '0%');
        return;
      }

      var rect = item.getBoundingClientRect();
      var progress = clamp((start - rect.top) / (start - end), 0, 1);
      var reveal = (1 - progress) * 100;

      figure.style.setProperty('--lowrise-reveal', reveal.toFixed(1) + '%');
    });
  }

  function requestLowriseUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateLowriseItems);
  }

  updateLowriseItems();
  window.addEventListener('scroll', requestLowriseUpdate, { passive: true });
  window.addEventListener('resize', requestLowriseUpdate);
});
